module.exports = __webpack_public_path__ + "static/img/guanwang11.4a4df4b3.png";